export default {
  getShowError: state => state.showError,
  getShowLoader: state => state.showLoader,
  getShowContent: state => state.showContent
};